module.exports = __webpack_public_path__ + "static/media/Investor@2x.9f9513de.png";